export function eligibleRequirement() {
    const eligibleRequirementList = [
        {
            "id": 1,
            "Name": "Youth",
            "Value": 'Enable_Student'
        },
        {
            "id": 2,
            "Name": "Influencers",
            "Value": 'Enable_Creator'
        },
        {
            "id": 3,
            "Name": "Music Artists",
            "Value": 'Enable_Artist'
        },
        {
            "id": 4,
            "Name": "All Users"
        }
    ]

    return eligibleRequirementList;
}


export function featuredRequirement() {
    const featuredList = [
        {
            "id": 1,
            "Name": "Featured",
            "Value": 'Is_featured',
            "helperText": '“Is Featured” will display your banner in the slider of the Offer/Internship/Gigwork section.',
        },
        {
            "id": 2,
            "Name": "Home Featured",
            "Value": 'Is_homefeatured',
            "helperText": '“Home Featured” will showcase your banner in the main slider on the home page.',
        }
    ]

    return featuredList;
}